// extracted by mini-css-extract-plugin
var _1 = "layout-module_appCloseText_neWz0";
var _2 = "layout-module_appCloseTextMobile_QdQG0";
var _3 = "layout-module_appCloseWrap_RiPt8";
var _4 = "layout-module_appCloseWrapDeskTop_imF5X";
var _5 = "layout-module_appCloseWrapMobile_KZC6j";
var _6 = "layout-module_authChildren_Y7xSq";
var _7 = "layout-module_authMainWrapper_Ko8oY";
var _8 = "layout-module_authWrapper_l6txk";
var _9 = "layout-module_avatar_oqlzI";
var _a = "layout-module_desktopStart_j3g56";
var _b = "layout-module_diffColImg_N5bq7";
var _c = "layout-module_diffColorWrapper_vWBjd";
var _d = "layout-module_eduDesktop__Kz9Q";
var _e = "layout-module_eduMobile_BCVZY";
var _f = "layout-module_extrasDesktop_Foibv";
var _10 = "layout-module_extrasMobile_ZOzAt";
var _11 = "layout-module_formLogoWrapper_vtkr0";
var _12 = "layout-module_formMainWrapper_igt0e";
var _13 = "layout-module_hamburgerIcon_OYOiQ";
var _14 = "layout-module_header_xp3Qp";
var _15 = "layout-module_headerIconSet_zLwx9";
var _16 = "layout-module_landingHeaderWrapper_Wr8Rq";
var _17 = "layout-module_landingLogo_zeD4c";
var _18 = "layout-module_landingMainWrapper_t7ICR";
var _19 = "layout-module_landingStartWrapper_chjca";
var _1a = "layout-module_learnDesktop_QCky7";
var _1b = "layout-module_learnMobile_HWJe4";
var _1c = "layout-module_logoWrapper_UfoXw";
var _1d = "layout-module_mobileStart_T3gpn";
var _1e = "layout-module_persDesktop_Y44Sm";
var _1f = "layout-module_persMobile_rcgum";
var _20 = "layout-module_rocketButtonEle_Q99Yb";
var _21 = "layout-module_tabText_aqODY";
var _22 = "layout-module_tabWrapper_z02dF";
export { _1 as "appCloseText", _2 as "appCloseTextMobile", _3 as "appCloseWrap", _4 as "appCloseWrapDeskTop", _5 as "appCloseWrapMobile", _6 as "authChildren", _7 as "authMainWrapper", _8 as "authWrapper", _9 as "avatar", _a as "desktopStart", _b as "diffColImg", _c as "diffColorWrapper", _d as "eduDesktop", _e as "eduMobile", _f as "extrasDesktop", _10 as "extrasMobile", _11 as "formLogoWrapper", _12 as "formMainWrapper", _13 as "hamburgerIcon", _14 as "header", _15 as "headerIconSet", _16 as "landingHeaderWrapper", _17 as "landingLogo", _18 as "landingMainWrapper", _19 as "landingStartWrapper", _1a as "learnDesktop", _1b as "learnMobile", _1c as "logoWrapper", _1d as "mobileStart", _1e as "persDesktop", _1f as "persMobile", _20 as "rocketButtonEle", _21 as "tabText", _22 as "tabWrapper" }
